var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseActionsheetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79569 4.3071C2.38494 3.8769 2.40453 3.19879 2.83944 2.79249C3.27435 2.38619 3.95989 2.40557 4.37063 2.83576L10 8.73171L15.6294 2.83576C16.0401 2.40557 16.7257 2.38619 17.1606 2.79249C17.5955 3.19879 17.6151 3.8769 17.2043 4.3071L11.7688 10L17.2043 15.6929C17.6151 16.1231 17.5955 16.8012 17.1606 17.2075C16.7257 17.6138 16.0401 17.5944 15.6294 17.1642L10 11.2683L4.37063 17.1642C3.95989 17.5944 3.27435 17.6138 2.83944 17.2075C2.40453 16.8012 2.38494 16.1231 2.79569 15.6929L8.23119 10L2.79569 4.3071Z",
    fill: "#62646E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseActionsheetIcon);
export default __webpack_public_path__ + "static/media/close_actionsheet_icon.32fb038bf6a4a54a61b6c1b06cb45904.svg";
export { ForwardRef as ReactComponent };